const getArticleIds = (layout) => {
  const idArr = []
  layout.forEach((row) => {
    row.cols.forEach((col) => {
      idArr.push(
        col.widgetArea.widgets
          .filter(
            (w) =>
              w.type === 'articleGrid' ||
              w.type === 'simpleArticleGrid' ||
              w.type === 'videoGrid' ||
              w.type === 'gridWithAdvert'
          )
          .map((w) => w.articles.results.map((a) => a._id))
          .flat()
      )
    })
  })
  const ids = idArr.flat()
  return ids
}

export default getArticleIds
